import React from 'react'

import { SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'

import ContentBox from 'components_new/molecules/ContentBox'
import SimpleTable from 'components_new/molecules/SimpleTable'

import { useActiveSource } from 'redux/hooks/Sources'
import { useParams } from 'utils/hooks'
import { getSourceCategory, SOURCE_CATEGORY_META } from 'utils/sources'

interface SourceAboutProps {
  sx?: SxProps
}

const SourceAbout = (props: SourceAboutProps) => {
  const { sx } = props

  const { id } = useParams<{ id: string }>()
  const { activeSource, source } = useActiveSource(id)

  if (!activeSource || !source) {
    return null
  }

  const category =
    SOURCE_CATEGORY_META[getSourceCategory(source.attributes.type)]
  const user = activeSource.included.user

  return (
    <Box sx={{ ...sx }}>
      <ContentBox
        collapse={{
          active: true,
          unmountOnExit: true
        }}
        color="default"
        gutterBottom={true}
        header={{
          icon: { name: 'Info' },
          title: 'Om'
        }}
      >
        <SimpleTable
          rows={[
            { cells: ['Typ', category.label] },
            {
              cells: [
                'Senaste körning',
                activeSource.attributes.latest_run_timestamp
                  ? String(activeSource.attributes.latest_run_timestamp)
                  : '-'
              ]
            },
            {
              cells: [
                'Skapades',
                activeSource.attributes.created_at.split('T')[0]
              ]
            },
            {
              cells: [
                'Skapades av',
                user
                  ? `${user.attributes.first_name} ${user.attributes.last_name}`
                  : 'Homepal'
              ]
            }
          ]}
        />
      </ContentBox>
    </Box>
  )
}

export default SourceAbout
